<template>
  <div class="brand-ambassador">
    <div class="banner">
      <v-img :src="`${currentDetails.bannerImage}`" alt="Banner" />
    </div>
    <div class="brand-ambassador-bg">
      <div class="carousel-wrapper">
        <button @click="scrollLeft" class="arrow left"><</button>
        <div class="sponsor-carousel" ref="carousel">
          <div v-for="(sponsor, index) in sponsorshipsData" :key="index" class="card" @click="clickSponsor(index)" :class="{ active: index === currentIndex }">
            <img :src="sponsor.logo" alt="Team Logo" />
            <p class="sponsor-name">{{ sponsor.name }}</p>
            <p class="sponsor-year">{{ sponsor.year }}</p>
          </div>
        </div>
        <button @click="scrollRight" class="arrow right">></button>
      </div>
      <div class="desc">
        <p class="sponsor-title">{{ currentDetails.title }}</p>
        <p class="sponsor-name">{{ currentDetails.name }}</p>
        <p class="sponsor-content" v-html="currentDetails.content" />
      </div>
      <div class="iframe-ambassador" v-if="currentDetails.videoSource">
        <iframe
            :src="`${currentDetails.videoSource}`"
            width="100%"
            height="100%"
            style="border: none; overflow: hidden; border-radius: 10px; aspect-ratio: 16/9"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen="false"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div class="gallery-wrapper">
        <button @click="scrollGalleryLeft" class="arrow left"><</button>
        <div class="gallery-carousel" ref="galleryCarousel">
          <div v-for="index in 6" :key="index" class="card">
            <img :src="`${currentDetails.gallery}_${index}.jpg`" />
          </div>
        </div>
        <button @click="scrollGalleryRight" class="arrow right">></button>
      </div>
    </div>
    <div class="bottom-banner">
      <v-img :src="`${currentDetails.bottomImage}`" alt="Bottom Banner" />
      <div class="bottom-line"></div>
    </div>
  </div>
</template>

<script>
  import {locale, uiHelper} from "@/util";
  import {SHARED} from "@/constants/constants";

  export default {
    name: 'brandAmbassador',
    data: () => ({
      currentIndex: 0,
      sponsorshipsData: [
        {
          name: 'SAMIRA MAHI KHAN',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/samira_khan.png',
          year: '2024/2025',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/samira_khan.jpg',
          title: 'OFFICIAL BRAND AMBASSADOR',
          content: locale.getMessage('sponsor.samiraMahiKhan'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/samira_khan',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/samira_khan.jpg',
          videoSource: 'https://geo.dailymotion.com/player/xbzld.html?video=xa0p7ba'
        },
        {
          name: 'APU BISWAS',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/apu_biswas.png',
          year: '2023/2024',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/apu_biswas.jpg',
          title: 'OFFICIAL BRAND AMBASSADOR',
          content: locale.getMessage('sponsor.apu_biswas'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/apu_biswas',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/apu_biswas.jpg',
          videoSource: 'https://geo.dailymotion.com/player/xbzld.html?video=xa0p7f2'
        }
      ]
    }),
    created() {
      this.metaTag();
      this.currentDetails();
    },
    computed: {
      currentDetails() {
        return this.sponsorshipsData[this.currentIndex]
      },
    },
    methods: {
      metaTag() {
        const currentUrl = window.location.href
        const domainWithProtocol = currentUrl.split('/')[2]
        const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
        const path = window.location.pathname
        const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
        const Links = `https://${domain}${cleanPath}`
        const Linksen = `https://${domain}/en-BD${cleanPath}`
        const Linksbn = `https://${domain}/bn-BD${cleanPath}`
        uiHelper.setHreflangLinks(Links)
        uiHelper.setHreflangLinksen(Linksen)
        uiHelper.setHreflangLinksbd(Linksbn)
      },
      clickSponsor(index) {
        this.currentIndex = index;
      },
      scrollLeft() {
        if(this.currentIndex > 0) {
          this.currentIndex --;
        }
      },
      scrollRight() {
        if(this.currentIndex < this.sponsorshipsData.length -1) {
          this.currentIndex ++;
        }
      },
      scrollGalleryLeft() {
        this.$refs.galleryCarousel.scrollBy({ left: -260, behavior: 'smooth' })
      },
      scrollGalleryRight() {
        this.$refs.galleryCarousel.scrollBy({ left: 260, behavior: 'smooth' })
      }
    }
  }
</script>

<style lang="scss">
  .brand-ambassador {
    width: 100%;
    max-width: 1280px;
    background: #fff;
    justify-self: center;

    .banner {
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }
    }

    .brand-ambassador-bg {
      background-color: #333333;
      padding: 20px 24px;

      @media (max-width: 599px) {
        padding: 12px;
      }

      .carousel-wrapper {
        display: flex;
        align-items: center;
        overflow: hidden;

        .sponsor-carousel {
          display: flex;
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-behavior: smooth;
          gap: 16px;
          margin: 0 16px;
          justify-content: center;

          @media (max-width: 599px) {
            gap: 10px;
            margin: 0 8px;
          }
        }

        .card {
          min-width: 180px;
          height: 120px;
          padding: 10px;
          text-align: center;
          color: white;
          background-color: #474747;
          cursor: pointer;

          @media (max-width: 599px) {
            min-width: 148px;
            height: 100px;
          }

          img {
            width: 52px;
            height: 52px;

            @media (max-width: 599px) {
              width: 40px;
              height: 40px;
              margin-bottom: -2px;
            }
          }

          .sponsor-name {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 0;

            @media (max-width: 599px) {
              font-size: 12px;
            }
          }

          .sponsor-year {
            font-size: 12px;

            @media (max-width: 599px) {
              font-size: 10px;
            }
          }
        }

        .card.active {
          color: #FFCE01;
          background-color: #1c1c1c;
        }

        .arrow {
          display: flex;
          font-size: 20px;
          width: 30px;
          height: 30px;
          border-radius: 16px;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          color: white;
          background-color: #0080F6;

          @media (max-width: 599px) {
            font-size: 16px;
            width: 24px;
            height: 24px;
          }
        }
      }

      .desc {
        text-align: center;
        color: white;
        padding-top: 20px;

        .sponsor-title {
          font-size: 24px;
          font-weight: bolder;
          font-style: italic;
          color: #FFCE01;
          text-transform: uppercase;
          margin-bottom: -12px;

          @media (max-width: 599px) {
            font-size: 14px;
            margin-bottom: -2px;
          }
        }

        .sponsor-name {
          font-size: 36px;
          font-weight: bolder;
          font-style: italic;
          text-transform: uppercase;

          @media (max-width: 599px) {
            font-size: 16px;
          }
        }

        .sponsor-league {
          font-size: 24px;
          font-weight: bold;
          font-style: italic;
          text-transform: uppercase;

          @media (max-width: 599px) {
            font-size: 12px;
          }
        }

        .sponsor-content {
          font-size: 16px;

          @media (max-width: 599px) {
            font-size: 12px;
          }
        }
      }

      .gallery-wrapper {
        display: flex;
        align-items: center;
        overflow: hidden;
        padding: 10px;

        .gallery-carousel {
          display: flex;
          width: 100%;
          overflow-x: auto;
          scroll-behavior: smooth;
          gap: 16px;
          margin: 0 16px;

          @media (max-width: 599px) {
            gap: 10px;
            margin: 0 8px;
          }
        }

        .card {
          min-width: 220px;

          @media (max-width: 599px) {
            min-width: 100px;
          }
        }

        .card img {
          width: 100%;
          height: auto;
        }

        .arrow {
          display: flex;
          font-size: 20px;
          width: 30px;
          height: 30px;
          border-radius: 16px;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          color: white;
          background-color: #0080F6;

          @media (max-width: 599px) {
            font-size: 16px;
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .bottom-banner {
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }

      .bottom-line {
        display: flex;
        width: 100%;
        height: 32px;
        background-color: #FFCE01;

        @media (max-width: 599px) {
          height: 12px;
        }
      }
    }
  }
</style>
